import { render, staticRenderFns } from "./mktButton.vue?vue&type=template&id=b996f29e&"
import script from "./mktButton.vue?vue&type=script&lang=js&"
export * from "./mktButton.vue?vue&type=script&lang=js&"
import style0 from "./mktButton.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports